module.exports = "/_next/static/images/illustration_ink-with-feather-f4265072c10c0f1125f053e2641f3ebb.svg";